import { render, staticRenderFns } from "./BrowsingHistory.vue?vue&type=template&id=6ac5c88f&scoped=true&"
import script from "./BrowsingHistory.vue?vue&type=script&lang=js&"
export * from "./BrowsingHistory.vue?vue&type=script&lang=js&"
import style0 from "./BrowsingHistory.vue?vue&type=style&index=0&id=6ac5c88f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac5c88f",
  null
  
)

export default component.exports